import React from "react"; 
import { Link } from "react-router-dom";    
import CreateAppUserForm from "./CreateAppUsersForm";

const CreateAppUser = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Create User</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>App Users List</li>
          <li>Create App User</li>
        </ul>
      </div> */}

      <CreateAppUserForm />
    </>
  );
};

export default CreateAppUser;
